<template>
  <a-modal :visible="visible" title="修改收货地址" @ok="handleOk" @cancel="handleCancel" ok-text="确定" cancel-text="取消" :confirm-loading="confirmLoading" width="600px" destroyOnClose>
    <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">

      <a-form-item label="所在地区" name="region">
        <a-cascader v-model:value="formState.region" :options="pcaData" placeholder="请选择省/市/区" :field-names="{ label: 'name', value: 'name', children: 'childs' }" change-on-select />
      </a-form-item>

      <a-form-item label="详细地址" name="detailAddress">
        <a-input v-model:value="formState.detailAddress" placeholder="街道门牌号等" />
      </a-form-item>

      <a-form-item label="收货人" name="receiverName">
        <a-input v-model:value="formState.receiverName" />
      </a-form-item>

      <a-form-item label="联系电话" name="receiverPhone">
        <a-input v-model:value="formState.receiverPhone" />
      </a-form-item>

      <!-- <a-form-item label="客户留言" name="customerComment">
        <a-textarea v-model:value="formState.customerComment" :rows="3" />
      </a-form-item> -->

    </a-form>
  </a-modal>
</template>

<script>
import pcaCode from '@/assets/json/pca-code.json'; // 确认路径
import { UpdateOrderAddress } from '@/api/order';

export default {
  name: 'AddressEditModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 虽然提交不再用 orderId，但可能仍需保留以备其他用途，或者可以移除
    orderId: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      confirmLoading: false,
      pcaData: pcaCode,
      expressId: null, // 【修改】用于存储 express.id
      formState: {
        region: [],
        detailAddress: '',
        receiverName: '',
        receiverPhone: '',
        customerComment: ''
      },
      rules: {
        region: [{ required: true, message: '请选择所在地区', type: 'array', trigger: 'change' }],
        detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        receiverName: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
        receiverPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      }
    };
  },
  methods: {
    initForm(expressData, comment) {
      if (!expressData) {
        this.resetForm();
        return;
      }

      // 【修改】获取 express.id
      // 假设传入的 expressData 就是 detail.express，其中包含 id 字段
      this.expressId = expressData.id;

      this.formState = {
        region: [], // 暂时置空，由用户重新选择
        detailAddress: expressData.detailAddress || '',
        receiverName: expressData.receiverName || '',
        receiverPhone: expressData.receiverPhone || '',
        customerComment: comment || ''
      };
    },

    async handleOk() {
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        const params = {
          // 【修改】这里传 expressId 而不是 orderId
          id: this.expressId,

          // 直接传中文名称
          province: this.formState.region[0],
          city: this.formState.region[1],
          district: this.formState.region[2] || '',

          detailAddress: this.formState.detailAddress,
          receiverName: this.formState.receiverName,
          receiverPhone: this.formState.receiverPhone,
          customerComment: this.formState.customerComment
        };

        const res = await UpdateOrderAddress(params);

        if (res.errCode === 0) {
          this.$message.success('修改成功');
          this.$emit('refresh');
          this.handleCancel();
        } else {
          this.$message.error(res.message || '修改失败');
        }
      } catch (error) {
        console.error(error);
        if (!error.errorFields) {
          this.$message.error('系统异常');
        }
      } finally {
        this.confirmLoading = false;
      }
    },

    handleCancel() {
      this.$refs.formRef?.resetFields();
      this.$emit('update:visible', false);
    },

    resetForm() {
      this.formState = {
        region: [],
        detailAddress: '',
        receiverName: '',
        receiverPhone: '',
        customerComment: ''
      };
      this.expressId = null;
    }
  }
};
</script>